module.exports = __webpack_public_path__ + "static/chal_fct2-c6cffdb693471838618c9dd4fee91228.jpg";